import { render, staticRenderFns } from "./BottomPlacementTabs.vue?vue&type=template&id=52643080"
import script from "./BottomPlacementTabs.vue?vue&type=script&lang=js"
export * from "./BottomPlacementTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports